import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const CircleDashIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><circle cx="12" cy="12" r="12" fill="currentColor" /><rect x="6" y="9" width="12" height="6" fill="white" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CircleDashIcon;